import React, {useEffect, useState} from "react";
import leaderboardHeader from "../../../resources/leaderboardHeader.png";
import logoRoll from "../../../resources/logoRoll.png";
import logoLuxdrop from "../../../resources/luxdropLogo.png";
import logoHypedrop from "../../../resources/logoHypedrop.png";
import logoCSGOBIG from "../../../resources/logoCSGOBIG.png";
import logoRAINGG from "../../../resources/logoRAINGG.svg";
import logoStake from "../../../resources/logoStake.png";
import {NavLink, Route, Routes, useLocation} from "react-router-dom";
import RollLeaderboard from "./RollLeaderboard";
import LuxdropLeaderboard from "./LuxdropLeaderboard";
import HypedropLeaderboard from "./HypedropLeaderboard";
import StakeLeaderboard from "./StakeLeaderboard";
import BigLeaderboard from "./BigLeaderboard";
import RainggLeaderboard from "./RainggLeaderboard";

const LeaderboardIndex = ({showMinimalDetails}) => {

    const location = useLocation();
    const [minimalDetails, setDetailsLevel] = useState(false);

    useEffect(() => {
        if(showMinimalDetails){
            setDetailsLevel(showMinimalDetails);
        }else{
            setDetailsLevel(false);
        }
    }, [showMinimalDetails]);

    return (
        <div className={`leaderboardBackdrop ${minimalDetails ? "min" : ""}`}>
            <div className={`container`}>

                <div className="leaderboardHeader">

                    <img src={leaderboardHeader} alt=""/>

                    <div className="leaderboardSwitcher">
                        {/*<NavLink className="leaderboardRoobet" to="" end>*/}
                        {/*    <img src={logoShuffle} alt=""/>*/}
                        {/*</NavLink>*/}
                        {/*<NavLink className="leaderboardCases" to="cases" end>*/}
                        {/*    <img src={logoCases} alt=""/>*/}
                        {/*</NavLink>*/}
                        {/*<NavLink className="leaderboardPackdraw" to="packdraw">*/}
                        {/*    <img src={logoPackdraw} alt=""/>*/}
                        {/*</NavLink>*/}
                        {/*<NavLink className="leaderboardClash" to="clash">*/}
                        {/*    <img src={logoClash} alt=""/>*/}
                        {/*</NavLink>*/}
                        <NavLink className="leaderboardStake" to="/leaderboard/stake">
                            <img src={logoStake} alt=""/>
                        </NavLink>
                        <NavLink className="leaderboardLuxdrop" to="/leaderboard/luxdrop" >
                            <img src={logoLuxdrop} alt=""/>
                        </NavLink>
                        <NavLink className="leaderboardRoll" to="/leaderboard/csgo-roll">
                            <img src={logoRoll} alt=""/>
                        </NavLink>
                        <NavLink className="leaderboardHypedrop" to="/leaderboard/hypedrop">
                            <img src={logoHypedrop} alt=""/>
                        </NavLink>
                        <NavLink className="leaderboardRaingg" to="/leaderboard/rain" end>
                            <img src={logoRAINGG} alt=""/>
                        </NavLink>
                    </div>

                </div>

                <div>
                    <Routes location={location}>
                        {/*<Route path="" element={<ShuffleLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                        {/*<Route path="shuffle" element={<ShuffleLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                        {/*<Route path="cases" element={<CasesLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                        {/*<Route path="packdraw" element={<PackdrawLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                        {/*<Route path="clash" element={<ClashLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                        <Route path="luxdrop" element={<LuxdropLeaderboard showMinimalDetails={minimalDetails}/>}/>
                        <Route path="csgo-roll" element={<RollLeaderboard showMinimalDetails={minimalDetails}/>}/>
                        <Route path="hypedrop" element={<HypedropLeaderboard showMinimalDetails={minimalDetails}/>}/>
                        <Route path="stake" element={<StakeLeaderboard showMinimalDetails={minimalDetails}/>}/>
                        <Route path="rain" element={<RainggLeaderboard showMinimalDetails={minimalDetails}/>}/>
                    </Routes>
                </div>


            </div>

        </div>
    );
}

export default LeaderboardIndex;